import { render, staticRenderFns } from "./platform_rule_list.vue?vue&type=template&id=55ac8e9e&scoped=true"
import script from "./platform_rule_list.vue?vue&type=script&lang=js"
export * from "./platform_rule_list.vue?vue&type=script&lang=js"
import style0 from "./platform_rule_list.vue?vue&type=style&index=0&id=55ac8e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ac8e9e",
  null
  
)

export default component.exports